import React from 'react'
import BaseComponent from "../../pages/base/BaseComponent";
import {Button, Card, OverlayTrigger, Table, Tooltip} from "@themesberg/react-bootstrap";
import label from "enqc-utilities/src/label/Label"
import {Link} from "react-router-dom";
import {Routes} from "../../routes";
import Endpoint from "enqc-utilities/src/api/Endpoint";
import {getUser} from "../../utils/StorageUtil";
import PropTypes from 'prop-types';
import {DD_MM_YYYY_HH_MM_SS, PARAM_DATE_FORMAT} from "../../utils/Global";
import PaginationTable from "../../components/PaginationTable";
import ApplicationIcons from "enqc-utilities/src/misc/ApplicationIcons";
import MyImage from "../../components/MyImage";
// import BorrowingOfItemDetailPage from "./BorrowingOfItemDetailPage";
import {navigate, parseDate} from "enqc-utilities/src/utils/Utilities";
import SmartDeviceInfoModal from "../../components/SmartDeviceInfoModal";
import GoodsItemDetailPage from "./GoodsItemDetailPage";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faInfo} from "@fortawesome/free-solid-svg-icons";
import UserDetailPage from "../management/UserDetailPage";


class BorrowingOfItemTable extends BaseComponent{

    constructor(props) {
        super(props);
        this.state = {
            show:false,
            search: "",
            user : getUser(),
            borrowingOfItemStatus:props.borrowingOfItemStatus?props.borrowingOfItemStatus:{},
            tabDataCallback:props.tabDataCallback?props.tabDataCallback:{},
            selectedSmartDeviceInfo:{},
            page: 1,
            borrowingOfItems:[],
            totalPage: 0,
            totalElement: 0,
            pageElement: 0
        }
    }
    componentDidMount() {
        super.componentDidMount();
        this.fetchBorrowingOfItems(undefined, undefined, undefined)
    }

    componentWillReceiveProps(props, nextContext) {
        let show = props.show?props.show:false
        let borrowingOfItemStatus = props.borrowingOfItemStatus?props.borrowingOfItemStatus:{}
        let tabDataCallback = props.tabDataCallback?props.tabDataCallback:{}
        this.setState({show, borrowingOfItemStatus, tabDataCallback},() => {
            if(show && !this.props.show){
                this.fetchBorrowingOfItems(undefined, {}, undefined, undefined)
            }
        })
    }

    goToPage(page){
        this.setState({page}, () => {
            this.refresh()
        })
    }

    refresh(){
        let {search, sortOption, filteredSmartDevices, filteredUsers, filteredGoodsCategories} = this.state
        this.fetchBorrowingOfItems(search, sortOption, filteredSmartDevices, filteredUsers, filteredGoodsCategories)
    }


    fetchBorrowingOfItems = (search, sortOption, filteredSmartDevices, filteredUsers, filteredGoodsCategories, startBorrowedAt, endBorrowedAt, startReturnedAt, endReturnedAt, downloadExcel) => {
        let {user, borrowingOfItemStatus, borrowingOfItems, tabDataCallback} = this.state
        let filterSmartDeviceIds = []
        if(filteredSmartDevices){
            filterSmartDeviceIds = new Array()
            filteredSmartDevices.forEach((item)=>{
                filterSmartDeviceIds.push(item.id)
            })
        }
        let filterUserIds = []
        if(filteredUsers){
            filterUserIds = new Array()
            filteredUsers.forEach((item)=>{
                filterUserIds.push(item.id)
            })
        }
        let filterGoodsCategoryIds = []
        if(filteredGoodsCategories){
            filterGoodsCategoryIds = new Array()
            filteredGoodsCategories.forEach((item)=>{
                filterGoodsCategoryIds.push(item.id)
            })
        }
        if(!sortOption){
            sortOption = {}
        }
        if(startBorrowedAt){
            startBorrowedAt = parseDate(startBorrowedAt, PARAM_DATE_FORMAT)
        }
        if(endBorrowedAt){
            endBorrowedAt = parseDate(endBorrowedAt, PARAM_DATE_FORMAT)
        }
        if(startReturnedAt){
            startReturnedAt = parseDate(startReturnedAt, PARAM_DATE_FORMAT)
        }
        if(endReturnedAt){
            endReturnedAt = parseDate(endReturnedAt, PARAM_DATE_FORMAT)
        }
        this.setState({
            search, sortOption, filteredSmartDevices, filteredUsers, filteredGoodsCategories
        }, async () => {
            let params = {
                params :{
                    borrowingOfItemStatusId : borrowingOfItemStatus.id==0?undefined:borrowingOfItemStatus.id,
                    ascending: sortOption.ascending,
                    sortir: sortOption.sortir,
                    search: search,
                    borrowedOnSmartDeviceIds:filterSmartDeviceIds.join(","),
                    borrowerIds:filterUserIds.join(','),
                    goodsCategoryIds:filterGoodsCategoryIds.join(","),
                    page: this.state.page - 1,
                    startBorrowedAt, endBorrowedAt, startReturnedAt, endReturnedAt
                }
            }
            if(downloadExcel){
                await this.asyncDownloadGet(Endpoint.API.BORROWING_ITEMS_DOWNLOAD_EXCEL, params, null, false, false)
            }else{
                this.get(Endpoint.API.BORROWING_ITEMS, params, null, response=>{
                    if(response.code===200){
                        let borrowingOfItems = response.data
                        let totalPage = response.totalPage
                        let totalElement = response.totalElement
                        let pageElement = response.pageElement
                        this.setState({borrowingOfItems:borrowingOfItems, totalPage, totalElement, pageElement}, () => {
                            if(tabDataCallback){
                                tabDataCallback(borrowingOfItemStatus.id, totalElement)
                            }
                        })
                    } else{
                        // this.props.history.goBack();
                    }
                }, false, true)
            }

            // this.get(Endpoint.API.BORROWING_ITEMS, {
            //     params :{
            //         borrowingOfItemStatusId : borrowingOfItemStatus.id==0?undefined:borrowingOfItemStatus.id,
            //         ascending: sortOption.ascending,
            //         sortir: sortOption.sortir,
            //         search: search,
            //         borrowedOnSmartDeviceIds:filterSmartDeviceIds.join(","),
            //         borrowerIds:filterUserIds.join(','),
            //         goodsCategoryIds:filterGoodsCategoryIds.join(","),
            //         page: this.state.page - 1,
            //         startBorrowedAt, endBorrowedAt, startReturnedAt, endReturnedAt
            //     }
            // }, null, response=>{
            //     if(response.code===200){
            //         let borrowingOfItems = response.data
            //         let totalPage = response.totalPage
            //         let totalElement = response.totalElement
            //         let pageElement = response.pageElement
            //         this.setState({borrowingOfItems:borrowingOfItems, totalPage, totalElement, pageElement}, () => {
            //             if(tabDataCallback){
            //                 tabDataCallback(borrowingOfItemStatus.id, totalElement)
            //             }
            //         })
            //     }
            // }, true, true)
        })
    }


    render() {
        let {user, borrowingOfItems, selectedSmartDeviceInfo, page, pageElement, totalPage, totalElement} = this.state
        return (
            <React.Fragment>
                <SmartDeviceInfoModal {...this.props}
                                      onClose={() => {
                                          this.setState({selectedSmartDeviceInfo:{}})
                                      }}
                                      show={selectedSmartDeviceInfo.id}
                                      smartDevice={selectedSmartDeviceInfo}/>
                <Card className="table-wrapper table-responsive">
                    <Card.Body className="p-0">
                        <Table size="sm" hover className="table-sm align-items-center p-0">
                            <thead>
                            <tr>
                                <th className="border-bottom pl-3 pr-3" style={{maxWidth:'30px'}}>#</th>
                                <th className="border-bottom pl-3 pr-3 border-end" style={{maxWidth:'190px'}}>{label.Goods}</th>
                                <th className="border-bottom pl-3 pr-3" style={{maxWidth:'190px'}}>{label.TakenFrom}</th>
                                <th className="border-bottom pl-3 pr-3" style={{maxWidth:'160px'}}>{label.Borrower}</th>
                                <th className="border-bottom pl-3 pr-3 border-end" style={{maxWidth:'150px'}}>{label.Time}</th>
                                <th className="border-bottom pl-3 pr-3 border-end text-center" style={{maxWidth:'180px'}}>{label.Status}</th>
                                <th className="border-bottom pl-3 pr-3" style={{maxWidth:'190px'}}>{label.ReturnedOn}</th>
                                <th className="border-bottom pl-3 pr-3" style={{maxWidth:'150px'}}>{label.Time}</th>
                            </tr>
                            </thead>
                            <tbody>
                            {borrowingOfItems.map((borrowingOfItem, index) => (
                                <tr key={index}>
                                    <td style={{maxWidth:'30px'}} className='pl-3 pr-3'>
                                        <Card.Link as={Link} to={Routes.Invoice.path} className="fw-normal">
                                            {((page - 1) * pageElement) + (index+1)}
                                        </Card.Link>
                                    </td>
                                    <td style={{maxWidth:'190px'}} className='pl-3 pr-3 border-end'>
                                        <span className="fw-normal fw-bolder">
                                            <Link
                                                style={{textDecoration:'underline'}}
                                                to={"#"}
                                                onClick={() => {
                                                    this.props.onSelect(borrowingOfItem)
                                                }}>
                                                {borrowingOfItem.goodsItem.goodsInfo.name}
                                            </Link>
                                        </span>
                                        <br/>
                                        <span className="text-blue fw-400 text-italic">
                                            <Link
                                                style={{textDecoration:'underline'}}
                                                to={GoodsItemDetailPage.ENDPOINT+"/"+borrowingOfItem.goodsItem.id}>
                                                {borrowingOfItem.goodsItem.rfidTag}
                                            </Link>
                                        </span>
                                        <br/>
                                        <span className="fw-normal fw-bolder">
                                            {borrowingOfItem.goodsItem.goodsInfo.goodsCategory.name}
                                            &nbsp;&nbsp;
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={<Tooltip id="tooltip-id">{borrowingOfItem.goodsItem.goodsInfo.goodsCategory.description}</Tooltip>}>
                                                <Button
                                                    variant="black"
                                                    className="p-0" size="sm"
                                                    style={{width:'18px', height:'18px'}}>
                                                <FontAwesomeIcon
                                                    style={{width:'10px', height:'10px'}}
                                                    size="sm" className="super-badge m-0" icon={faInfo}/>
                                                </Button>
                                            </OverlayTrigger>
                                        </span>
                                    </td>
                                    <td style={{maxWidth:'190px'}} className='pl-3 pr-3'>
                                        <Button
                                            size="sm"
                                            variant="white"
                                            className="fw-normal white btn-outline-danger"
                                            style={{color:'black', backgroundColor:'white'}}
                                            onClick={event => {
                                                this.setState({selectedSmartDeviceInfo:borrowingOfItem.borrowedOnSmartDevice})
                                            }}>
                                            <MyImage src={ApplicationIcons.Icons.notAllocated} style={{width:'18px'}} />&nbsp;
                                            {borrowingOfItem.borrowedOnSmartDevice.deviceId}
                                        </Button>
                                    </td>
                                    <td style={{maxWidth:'160px'}} className='pl-3 pr-3'>
                                        <Button
                                            size="sm"
                                            variant={"outline-info"}
                                            className="fw-normal p-1"
                                            style={{color:'black', backgroundColor:'white'}}
                                            onClick={event => {
                                                navigate(this.props, UserDetailPage.ENDPOINT+"/"+borrowingOfItem.borrower.userCode)
                                            }}
                                            color={"red"}>
                                            <MyImage src={ApplicationIcons.Icons.userAvatar} style={{width:'16px'}} />&nbsp;
                                            {borrowingOfItem.borrower.fullname}
                                        </Button>
                                    </td>
                                    <td style={{maxWidth:'150px'}} className='pl-3 pr-3 border-end'>
                                        <span className="fw-normal">
                                            {parseDate(borrowingOfItem.borrowedAt, DD_MM_YYYY_HH_MM_SS)}
                                        </span>
                                    </td>
                                    <td style={{maxWidth:'180px'}} className='pl-3 pr-3 border-end text-center'>
                                        <Button
                                            size="sm"
                                            className="fw-normal font-small"
                                            disabled={true}
                                            style={{backgroundColor:(borrowingOfItem.borrowingOfItemStatus?borrowingOfItem.borrowingOfItemStatus.color:undefined)}}>
                                            {borrowingOfItem.borrowingOfItemStatus?label(borrowingOfItem.borrowingOfItemStatus.label):"-"}
                                        </Button>
                                    </td>
                                    <td style={{maxWidth:'190px'}} className='pl-3 pr-3'>
                                        {borrowingOfItem.returnedOnSmartDevice?(
                                            <Button
                                                size="sm"
                                                variant={"outline-info"}
                                                className="fw-normal"
                                                style={{color:'black', backgroundColor:'white'}}
                                                onClick={event => {
                                                    this.setState({selectedSmartDeviceInfo:borrowingOfItem.returnedOnSmartDevice})
                                                }}>
                                                <MyImage src={ApplicationIcons.Icons.allocated} style={{width:'18px'}} />&nbsp;
                                                {borrowingOfItem.returnedOnSmartDevice.deviceId}
                                            </Button>
                                        ):null}
                                    </td>
                                    <td style={{maxWidth:'150px'}} className='pl-3 pr-3'>
                                        {borrowingOfItem.returnedOnSmartDevice?(
                                            <span className="fw-normal">
                                                {parseDate(borrowingOfItem.returnedAt, DD_MM_YYYY_HH_MM_SS)}
                                            </span>
                                        ):null}
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>
                    </Card.Body>
                    <PaginationTable
                        onSelect={(page) => {
                            this.goToPage(page)
                        }}
                        showingRow={borrowingOfItems.length}
                        currentPage={page}
                        pageCount={totalPage}
                        totalElement={totalElement}/>
                </Card>
            </React.Fragment>
        );
    }

}
BorrowingOfItemTable.propTypes = {
    show:PropTypes.bool.isRequired,
    borrowingOfItemStatus:PropTypes.any.isRequired,
    onSelect:PropTypes.func.isRequired,
    tabDataCallback:PropTypes.func,
}


export default BorrowingOfItemTable